export const EO_CREATE_EVENT_STEPPER_STEPS_TITLES = [
  { label: "General Information", isCompleted: true },
  { label: "Seller Related Information", isCompleted: false },
  { label: "Event Fee", isCompleted: false },
  { label: "Additional Information", isCompleted: false },
];

export const MPS_EVENT_REGISTRATION_STEPPER_STEP_TITLES = [
  { label: "Apply to Event", isCompleted: true },
  { label: "Confirm Business Information", isCompleted: false },
  { label: "Additional Questions", isCompleted: false },
];
